import React, { useState } from 'react';

const SECTIONS = {
  cgu: {
    title: "Conditions Générales d'Utilisation",
    lastUpdate: '4 avril 2026',
    content: [
      {
        heading: "1. Objet et champ d'application",
        text: `Les présentes Conditions Générales d'Utilisation (« CGU ») régissent l'accès et l'utilisation de la plateforme Havenly, accessible à l'adresse havenly.fr, éditée par Havenly, auto-entrepreneur dont le siège social est situé au 56 Allée Robert Jondet, 83520 Roquebrune-sur-Argens, France (SIRET : 844 506 329 00037).

En accédant à la plateforme, l'utilisateur reconnaît avoir lu, compris et accepté sans réserve les présentes CGU. Si vous n'acceptez pas ces conditions dans leur intégralité, vous devez cesser d'utiliser la plateforme.

Les présentes CGU s'appliquent conjointement aux Conditions Générales de Vente (CGV), à la Politique de Confidentialité et à la Politique relative aux Cookies, accessibles depuis la même page.`,
      },
      {
        heading: "2. Définitions",
        text: `Au sens des présentes CGU, les termes suivants ont la signification indiquée ci-après :

• Plateforme : le site internet havenly.fr, ses applications mobiles et l'ensemble des services associés.
• Havenly : la société éditrice de la plateforme, agissant en qualité d'intermédiaire technique.
• Utilisateur : toute personne physique majeure (18 ans révolus) accédant à la plateforme, qu'elle soit Hôte ou Voyageur.
• Hôte : utilisateur proposant un logement à la location sur la plateforme.
• Voyageur : utilisateur recherchant et effectuant une réservation de logement.
• Annonce : description d'un logement publiée par un Hôte sur la plateforme.
• Réservation : accord contractuel conclu directement entre un Voyageur et un Hôte, via la plateforme.
• Emma IA : assistant conversationnel intégré à la plateforme, développé par Havenly.
• Contenu : tout élément publié sur la plateforme par un utilisateur (photos, textes, avis, descriptions).`,
      },
      {
        heading: "3. Accès à la plateforme — Conditions d'inscription",
        text: `L'inscription sur Havenly est réservée aux personnes physiques majeures ayant la pleine capacité juridique (18 ans révolus). Toute personne mineure est strictement exclue de l'utilisation de la plateforme.

Si un Voyageur réserve un séjour pour un groupe incluant des mineurs, il doit être légalement habilité à agir en leur nom et assume seul l'entière responsabilité de leur supervision pendant le séjour.

L'utilisateur s'engage à fournir des informations exactes, complètes et à jour lors de l'inscription. Toute fausse déclaration engage la responsabilité exclusive de son auteur et peut entraîner la suppression immédiate du compte.

Chaque utilisateur est responsable de la confidentialité de ses identifiants de connexion. Il s'engage à notifier immédiatement Havenly à contact@havenly.fr de toute utilisation non autorisée de son compte.`,
      },
      {
        heading: "4. Rôle de Havenly — Statut d'intermédiaire",
        text: `Havenly agit exclusivement en qualité d'intermédiaire technique de mise en relation entre Hôtes et Voyageurs. À ce titre :

• Havenly n'est pas partie au contrat de location conclu entre l'Hôte et le Voyageur.
• Havenly n'est ni bailleur, ni locataire, ni agent immobilier, ni organisateur de voyages au sens de la directive européenne 2015/2302.
• Le contrat de location est conclu directement et exclusivement entre l'Hôte et le Voyageur, dès la confirmation de réservation.
• Havenly n'est pas en mesure de garantir la qualité, la conformité ou la sécurité des logements proposés, ni le comportement des utilisateurs.

Havenly met à disposition des utilisateurs :
- Une plateforme de mise en relation entre Hôtes et Voyageurs.
- Un système de paiement sécurisé via Stripe (prestataire agréé PCI-DSS).
- Un service de médiation en cas de litige entre utilisateurs.
- L'assistant IA Emma pour la gestion automatisée des communications.
- Un système de vérification de l'identité des Hôtes.`,
      },
      {
        heading: "5. Obligations des Hôtes",
        text: `L'Hôte s'engage à :

• Fournir des informations exactes, complètes et à jour sur son logement (description, photos, équipements, règles).
• Respecter l'ensemble de la législation applicable : déclaration en mairie (Loi Le Meur du 19 novembre 2024), numéro d'enregistrement, limitation à 120 nuits/an pour une résidence principale.
• Disposer d'une assurance habitation couvrant expressément les activités de location courte durée.
• Fournir un logement conforme à l'annonce publiée, propre, sécurisé et en bon état de fonctionnement.
• Déclarer et reverser la taxe de séjour auprès des autorités compétentes. Havenly ne collecte pas la taxe de séjour pour le compte des Hôtes. Cette obligation incombe exclusivement à l'Hôte.
• Ne pas discriminer les Voyageurs sur quelque critère que ce soit, conformément à la loi du 27 mai 2008.
• Respecter les droits des Voyageurs en matière de protection des données personnelles.`,
      },
      {
        heading: "6. Obligations des Voyageurs",
        text: `Le Voyageur s'engage à :

• Utiliser le logement conformément aux règles fixées par l'Hôte dans l'annonce.
• Ne pas sous-louer le logement, ni en céder l'accès à des tiers non déclarés lors de la réservation.
• Ne pas dépasser la capacité maximale de voyageurs indiquée dans l'annonce.
• Signaler tout problème ou non-conformité à l'Hôte puis à Havenly dans les 24h suivant l'arrivée.
• Laisser le logement dans l'état dans lequel il l'a trouvé à l'arrivée.
• Ne pas organiser de fêtes, événements ou rassemblements non autorisés par l'Hôte.
• Agir avec respect envers l'Hôte, le logement et le voisinage.`,
      },
      {
        heading: "7. Contenu utilisateur — Licence et responsabilité",
        text: `En publiant du Contenu sur la plateforme Havenly (photos, descriptions, avis, commentaires), l'utilisateur :

• Concède à Havenly une licence non exclusive, mondiale, gratuite et sous-licenciable pour utiliser, reproduire, adapter et diffuser ce Contenu aux seules fins de promotion et de fonctionnement de la plateforme.
• Garantit être titulaire des droits nécessaires sur le Contenu publié.
• Reconnaît être seul responsable du Contenu qu'il publie.
• S'engage à ne pas publier de Contenu trompeur, discriminatoire, diffamatoire ou contraire à l'ordre public.

Havenly se réserve le droit de supprimer tout Contenu contraire aux présentes CGU, sans préavis ni indemnité.`,
      },
      {
        heading: "8. Non-discrimination",
        text: `Conformément à la loi du 27 mai 2008, Havenly interdit formellement toute discrimination fondée sur l'origine, le sexe, la situation de famille, l'état de grossesse, l'apparence physique, la vulnérabilité économique, le patronyme, le lieu de résidence, l'état de santé, le handicap, les caractéristiques génétiques, les mœurs, l'orientation sexuelle, l'identité de genre, l'âge, les opinions politiques, les activités syndicales, l'appartenance ou la non-appartenance à une ethnie, une nation ou une religion.

Tout manquement peut entraîner la suspension immédiate et définitive du compte concerné.`,
      },
      {
        heading: "9. Propriété intellectuelle",
        text: `L'ensemble des éléments constituant la plateforme Havenly (marque, logo, charte graphique, textes, algorithmes, code source, base de données) est protégé par le droit de la propriété intellectuelle français et international.

Toute reproduction, représentation, modification ou adaptation sans autorisation écrite préalable de Havenly est interdite et constitue une contrefaçon sanctionnée par les articles L.335-2 et suivants du Code de la propriété intellectuelle.`,
      },
      {
        heading: "10. Limitation de responsabilité",
        text: `Havenly ne saurait être tenu responsable des dommages résultant du comportement des utilisateurs, de l'inexactitude des annonces ou de tout incident survenant pendant un séjour.

La responsabilité de Havenly est limitée aux dommages directs et ne peut excéder le montant des commissions effectivement perçues sur la réservation concernée. Cette limitation ne s'applique pas en cas de faute lourde ou dolosive, ni en cas de dommages corporels.`,
      },
      {
        heading: "11. Suspension et résiliation du compte",
        text: `L'utilisateur peut supprimer son compte à tout moment depuis ses paramètres ou en contactant contact@havenly.fr.

Havenly peut suspendre ou résilier un compte en cas de : violation des CGU, comportement frauduleux, mauvais avis répétés avérés (mise en demeure préalable 7 jours), ou inactivité prolongée de plus de 24 mois (préavis 30 jours).

L'utilisateur peut contester toute décision de suspension par email motivé à contact@havenly.fr dans les 15 jours suivant la notification.`,
      },
      {
        heading: "12. Emma IA — Utilisation et limitations",
        text: `Emma est un assistant conversationnel basé sur l'intelligence artificielle mis à disposition des Hôtes pour automatiser les réponses aux Voyageurs.

L'Hôte demeure seul responsable des communications envoyées par Emma en son nom. Havenly ne garantit pas l'exactitude ou l'exhaustivité des réponses générées. Emma ne constitue pas un conseil juridique, fiscal ou professionnel.`,
      },
      {
        heading: "13. Modification des CGU",
        text: `Havenly se réserve le droit de modifier les présentes CGU à tout moment, avec un préavis minimum de 30 jours par email avant la date d'entrée en vigueur. La poursuite de l'utilisation de la plateforme vaut acceptation des nouvelles CGU.`,
      },
      {
        heading: "14. Droit applicable et juridiction compétente",
        text: `Les présentes CGU sont soumises au droit français. En cas de litige, les parties s'engagent à rechercher une solution amiable dans un délai de 30 jours.

Médiation gratuite : Médiation du Tourisme et du Voyage (MTV) — mtv.travel — BP 80 303, 75 823 Paris Cedex 17.
Plateforme européenne : ec.europa.eu/consumers/odr

À défaut de résolution amiable, tout litige sera soumis aux tribunaux français compétents.`,
      },
    ],
  },

  cgv: {
    title: 'Conditions Générales de Vente',
    lastUpdate: '4 avril 2026',
    content: [
      {
        heading: "1. Champ d'application",
        text: `Les présentes CGV s'appliquent à toutes les réservations effectuées sur havenly.fr entre un Voyageur et un Hôte. Havenly intervient exclusivement en qualité d'intermédiaire technique et de paiement. Le contrat de location est conclu directement entre le Voyageur et l'Hôte.`,
      },
      {
        heading: "2. Prix et transparence tarifaire",
        text: `Havenly s'engage à une transparence tarifaire totale. Le prix affiché avant confirmation est le prix définitif et comprend :

• Le prix de la nuitée fixé librement par l'Hôte.
• Les frais de ménage éventuels, fixés par l'Hôte.
• La taxe de séjour applicable, dont le montant est fixé par l'Hôte.

Aucun frais de service n'est facturé au Voyageur. Ce que vous voyez est ce que vous payez.

La commission Havenly (8% ou 12% selon le statut de l'Hôte) est déduite directement du versement de l'Hôte.`,
      },
      {
        heading: "3. Processus de réservation",
        text: `1. Le Voyageur soumet une demande — la carte est préautorisée sans débit immédiat.
2. L'Hôte dispose de 24h pour accepter ou refuser. Sans réponse, la demande est annulée.
3. En cas d'acceptation, la carte du Voyageur est débitée du montant total.
4. Le Voyageur reçoit une confirmation par email, incluant les accès au logement 48h avant l'arrivée.
5. Un dépôt de garantie est autorisé au check-in.
6. L'Hôte reçoit son versement dans les 24h suivant le check-in.
7. Le dépôt de garantie est libéré automatiquement 48h après le check-out en l'absence de litige.`,
      },
      {
        heading: "4. Politique d'annulation — Voyageur",
        text: `• Annulation gratuite : jusqu'à 14 jours avant l'arrivée — remboursement intégral.
• Annulation modérée : entre 7 et 14 jours — remboursement de 50% (hors taxe de séjour).
• Annulation tardive : moins de 7 jours — aucun remboursement.

Circonstances extraordinaires (hospitalisation, décès d'un proche, catastrophe naturelle) : remboursement possible sur justificatif, à formuler dans les 48h suivant l'événement.`,
      },
      {
        heading: "5. Politique d'annulation — Hôte",
        text: `L'Hôte ne peut annuler une réservation confirmée sans motif légitime (force majeure justifiée). En cas d'annulation par l'Hôte :

• Le Voyageur est remboursé intégralement sous 5 à 10 jours ouvrés.
• Havenly peut appliquer une pénalité à l'Hôte (retenue sur versements futurs, suspension de l'annonce, résiliation en cas de récidive).`,
      },
      {
        heading: "6. Protection Séjour Havenly — Dépôt de garantie",
        text: `Le dépôt de garantie est une simple autorisation bancaire (non un débit effectif), levée automatiquement 48h après le départ en l'absence de litige.

Montant : entre 50€ et 500€, fixé par l'Hôte (conseillé : 70€ à 150€).

En cas de dommage avéré, l'Hôte doit signaler le litige dans les 72h suivant le départ, avec photos horodatées avant/après et devis professionnel. Havenly instruit le dossier sous 72h.

Exclusions : usure normale, dommages antérieurs au séjour, catastrophes naturelles, dommages immatériels.

Havenly recommande vivement une assurance habitation couvrant la location courte durée.`,
      },
      {
        heading: "7. Litiges et médiation",
        text: `Étape 1 — Résolution directe (48h) : signalement à l'Hôte via la messagerie dans les 24h suivant l'arrivée.
Étape 2 — Médiation Havenly (72h) : ouverture d'un litige via la plateforme si aucune résolution.
Étape 3 — Urgence : logement inhabitable → relogement ou remboursement intégral sous 24h.
Étape 4 — Médiation externe : MTV — mtv.travel — BP 80 303, 75 823 Paris Cedex 17.`,
      },
      {
        heading: "8. Paiement et sécurité",
        text: `Tous les paiements sont traités par Stripe (agréé PCI-DSS niveau 1). Havenly ne stocke aucune donnée bancaire.

Moyens acceptés : Visa, Mastercard, American Express, Apple Pay, Google Pay. Devise : Euro (€).

Versement Hôte : dans les 24h suivant le check-in, sous réserve de connexion du compte bancaire via Stripe Connect.`,
      },
      {
        heading: "9. Commission Havenly",
        text: `• Hôtes Fondateurs (50 premiers) : 8% à vie, garanti contractuellement.
• Hôtes Standard : 8% les 3 premiers mois, puis 12%.

La commission couvre : accès à la plateforme, paiements Stripe, support, Emma IA, vérification d'identité et médiation.`,
      },
      {
        heading: "10. Facturation",
        text: `Un récapitulatif détaillé est envoyé au Voyageur par email après confirmation. Les Hôtes accèdent à l'historique de leurs transactions via leur tableau de bord.`,
      },
      {
        heading: "11. Droit de rétractation",
        text: `Conformément à l'article L.221-28 12° du Code de la consommation, le droit de rétractation de 14 jours ne s'applique pas aux prestations d'hébergement avec une date d'exécution spécifique. La politique d'annulation (article 4) est le seul mécanisme de remboursement applicable.`,
      },
    ],
  },

  confidentialite: {
    title: 'Politique de Confidentialité',
    lastUpdate: '4 avril 2026',
    content: [
      {
        heading: "1. Responsable du traitement",
        text: `Le responsable du traitement des données personnelles collectées sur havenly.fr est :

Havenly — Matthieu Perez, auto-entrepreneur
Siège social : 56 Allée Robert Jondet, 83520 Roquebrune-sur-Argens, France
SIRET : 844 506 329 00037
Contact : contact@havenly.fr

Havenly s'engage à traiter vos données personnelles conformément au RGPD (UE) 2016/679 et à la loi Informatique et Libertés du 6 janvier 1978 modifiée.`,
      },
      {
        heading: "2. Données collectées",
        text: `Données d'identification : nom, prénom, adresse email, numéro de téléphone, photo de profil.

Données de vérification (Hôtes) : pièce d'identité, selfie, justificatif d'assurance, numéro d'enregistrement en mairie.

Données de paiement : traitées intégralement par Stripe (agréé PCI-DSS). Havenly ne stocke aucune donnée bancaire.

Données de navigation : adresse IP, type de navigateur, pages visitées, durée de visite, cookies.

Données de transaction : historique des réservations, avis publiés, messages échangés via la plateforme.

Données Emma IA : conversations traitées par l'assistant IA, conservées pour améliorer le service.`,
      },
      {
        heading: "3. Finalités du traitement",
        text: `• Gestion des comptes utilisateurs et authentification.
• Traitement des réservations et des paiements.
• Prévention de la fraude et sécurisation de la plateforme.
• Communication relative à votre compte.
• Vérification de l'identité des Hôtes.
• Traitement des litiges et médiation.
• Amélioration des services.
• Respect des obligations légales.`,
      },
      {
        heading: "4. Base légale du traitement",
        text: `• Exécution du contrat : traitement des réservations, versements, communications liées au séjour.
• Obligation légale : conservation comptable et fiscale, vérification d'identité des Hôtes.
• Intérêt légitime : prévention de la fraude, amélioration des services.
• Consentement : communications marketing (optionnelles), cookies non essentiels.`,
      },
      {
        heading: "5. Durée de conservation",
        text: `• Données de compte : durée de vie du compte + 3 ans après suppression.
• Données de transaction : 10 ans (obligation comptable légale).
• Données de vérification d'identité (Hôtes) : 5 ans après la dernière transaction.
• Messages et avis : 5 ans après la fin de la relation contractuelle.
• Données de navigation et cookies : 13 mois maximum.
• Données relatives aux litiges : 5 ans à compter de la clôture.`,
      },
      {
        heading: "6. Destinataires des données",
        text: `• Stripe : traitement sécurisé des paiements.
• Supabase : hébergement de la base de données (serveurs en Europe).
• Vercel : hébergement du site web (États-Unis — garanties via clauses contractuelles types).
• Resend : envoi des emails transactionnels.
• Autorités compétentes : sur réquisition judiciaire légalement fondée.

Havenly ne vend jamais vos données personnelles à des tiers. Aucune donnée n'est communiquée à des fins publicitaires.`,
      },
      {
        heading: "7. Vos droits (RGPD)",
        text: `Vous disposez des droits suivants : accès (art. 15), rectification (art. 16), effacement (art. 17), portabilité (art. 20), opposition (art. 21), limitation (art. 18), retrait du consentement à tout moment.

Pour exercer vos droits : contact@havenly.fr — réponse sous 30 jours.

Réclamation : CNIL — cnil.fr — 3 Place de Fontenoy, 75007 Paris.`,
      },
      {
        heading: "8. Sécurité des données",
        text: `• Chiffrement des données en transit (TLS/SSL) et au repos.
• Authentification sécurisée via Supabase Auth.
• Accès aux données limité aux seules personnes habilitées.
• Hébergement des données en Europe (Supabase).
• Sauvegardes régulières et plan de continuité.

En cas de violation de données, Havenly s'engage à vous informer dans les meilleurs délais (art. 34 RGPD).`,
      },
      {
        heading: "9. Données relatives aux mineurs",
        text: `La plateforme Havenly est strictement réservée aux personnes majeures (18 ans révolus). Havenly ne collecte pas sciemment de données relatives à des mineurs. Contactez contact@havenly.fr pour toute demande de suppression.`,
      },
    ],
  },

  cookies: {
    title: 'Gestion des Cookies',
    lastUpdate: '4 avril 2026',
    content: [
      {
        heading: "1. Qu'est-ce qu'un cookie ?",
        text: `Un cookie est un petit fichier texte déposé sur votre terminal lors de votre navigation sur Havenly. Il permet de mémoriser des informations relatives à votre navigation afin d'améliorer votre expérience et de sécuriser la plateforme.

Conformément à la réglementation CNIL et aux lignes directrices du 17 septembre 2020, certains cookies ne peuvent être déposés qu'avec votre consentement préalable.`,
      },
      {
        heading: "2. Cookies strictement nécessaires (toujours actifs)",
        text: `Ces cookies sont indispensables au fonctionnement de la plateforme et ne nécessitent pas votre consentement.

• Cookie de session d'authentification : maintient votre connexion active.
• Cookie de sécurité CSRF : protège contre les attaques de falsification.
• Cookie de réservation en cours : mémorise votre réservation pendant la navigation.
• Cookies Stripe : nécessaires au traitement sécurisé des paiements.
• Cookies Supabase : nécessaires à l'authentification sécurisée.`,
      },
      {
        heading: "3. Cookies analytiques (avec consentement)",
        text: `Ces cookies permettent d'analyser l'utilisation de la plateforme de façon anonymisée.

• Mesure d'audience anonymisée (pages les plus visitées, durée de visite, parcours).
• Détection des erreurs techniques.
• Optimisation des performances.

Ces données sont agrégées et anonymisées : elles ne permettent pas de vous identifier individuellement.`,
      },
      {
        heading: "4. Cookies de préférences (avec consentement)",
        text: `Ces cookies permettent de personnaliser votre expérience.

• Mémorisation de vos recherches récentes.
• Logements consultés récemment.
• Préférences d'affichage (langue, filtres).

Havenly n'utilise aucun cookie publicitaire ou de tracking comportemental.`,
      },
      {
        heading: "5. Durée de conservation des cookies",
        text: `• Cookies de session : supprimés à la fermeture du navigateur.
• Cookies persistants : conservation maximale de 13 mois (recommandations CNIL).
• Votre consentement est mémorisé pendant 6 mois.`,
      },
      {
        heading: "6. Gérer vos préférences",
        text: `Vous pouvez modifier vos préférences à tout moment :

• Via le bandeau de consentement lors de votre première visite.
• Via les paramètres de votre navigateur :
  - Chrome : Paramètres > Confidentialité et sécurité > Cookies.
  - Firefox : Options > Vie privée et sécurité > Cookies.
  - Safari : Préférences > Confidentialité > Cookies.
  - Edge : Paramètres > Confidentialité > Cookies.
• En nous contactant à contact@havenly.fr.`,
      },
    ],
  },

  mentions: {
    title: 'Mentions Légales',
    lastUpdate: '4 avril 2026',
    content: [
      {
        heading: "Éditeur du site",
        text: `Nom commercial : Havenly
Forme juridique : Auto-entrepreneur (Entrepreneur Individuel)
Dirigeant : Matthieu Perez
Siège social : 56 Allée Robert Jondet, 83520 Roquebrune-sur-Argens, France
SIRET : 844 506 329 00037
N° TVA intracommunautaire : Non assujetti (franchise en base de TVA — article 293 B du CGI)
Directeur de la publication : Matthieu Perez
Email : contact@havenly.fr
Site web : havenly.fr`,
      },
      {
        heading: "Hébergeur du site",
        text: `Vercel Inc.
440 N Barranca Ave #4133
Covina, CA 91723 — États-Unis
Site : vercel.com

Base de données :
Supabase Inc.
970 Toa Payoh North #07-04
Singapore 318992
Site : supabase.com`,
      },
      {
        heading: "Activité réglementée",
        text: `Havenly est une plateforme numérique de mise en relation entre particuliers pour la location de logements de courte durée. Havenly n'exerce pas d'activité d'agent immobilier au sens de la loi Hoguet du 2 janvier 1970 et ne détient pas de carte professionnelle.

Havenly n'est pas un organisateur ou détaillant de voyages au sens du Code du tourisme (article L.211-1 et suivants).`,
      },
      {
        heading: "Propriété intellectuelle",
        text: `L'ensemble du contenu du site havenly.fr (marque, logo, charte graphique, textes, photographies, algorithmes, code source) est protégé par le droit de la propriété intellectuelle français et international.

La marque « Havenly » est une marque en cours d'enregistrement. Toute reproduction ou utilisation non autorisée est interdite et constitue une contrefaçon sanctionnée par les articles L.335-2 et suivants du Code de la propriété intellectuelle.`,
      },
      {
        heading: "Liens hypertextes",
        text: `La création de liens hypertextes vers havenly.fr est autorisée sans demande préalable, à condition que le lien ne soit pas utilisé à des fins commerciales trompeuses ou susceptibles de porter atteinte à l'image de Havenly.

Havenly n'est pas responsable du contenu des sites tiers vers lesquels des liens peuvent être proposés sur la plateforme.`,
      },
      {
        heading: "Médiation de la consommation",
        text: `Conformément aux articles L.616-1 et R.616-1 du Code de la consommation, en cas de litige non résolu, vous pouvez saisir gratuitement :

Médiation du Tourisme et du Voyage (MTV)
BP 80 303 — 75 823 Paris Cedex 17
Site : mtv.travel

Plateforme européenne de résolution en ligne des litiges :
ec.europa.eu/consumers/odr`,
      },
      {
        heading: "Signalement de contenus illicites",
        text: `Conformément à la loi LCEN du 21 juin 2004 et au Règlement DSA (UE) 2022/2065, tout utilisateur peut signaler un contenu manifestement illicite à :

contact@havenly.fr — objet : « Signalement contenu illicite »

Havenly traitera votre signalement dans les meilleurs délais.`,
      },
      {
        heading: "Loi applicable",
        text: `Le site havenly.fr et son contenu sont soumis au droit français. Tout litige relatif au site sera soumis à la compétence des tribunaux français compétents.`,
      },
    ],
  },

  proprietaires: {
    title: 'Relation Propriétaires — Conciergeries',
    lastUpdate: '17 mai 2026',
    content: [
      {
        heading: "1. Objet du service de gestion déléguée",
        text: `Havenly propose aux conciergeries partenaires un outil de gestion déléguée permettant de publier et gérer des annonces de location courte durée pour le compte de propriétaires tiers.

Dans ce cadre, Havenly agit exclusivement en qualité d'intermédiaire technique entre trois parties : le propriétaire du bien, la conciergerie mandatée, et le voyageur. Havenly n'est pas partie au mandat de gestion conclu entre le propriétaire et la conciergerie.`,
      },
      {
        heading: "2. Rôle et responsabilités de la conciergerie",
        text: `La conciergerie s'engage à :

• Disposer d'un mandat écrit signé par le propriétaire l'autorisant à publier et gérer le bien sur Havenly.
• Informer le propriétaire de l'ensemble des conditions d'utilisation de la plateforme, notamment les commissions appliquées.
• Configurer correctement le split de reversement (pourcentage ou forfait) reflétant fidèlement les honoraires convenus avec le propriétaire.
• Ne pas publier d'annonce sans l'accord explicite du propriétaire concerné.
• S'assurer que le bien respecte les obligations légales (déclaration en mairie, numéro d'enregistrement, assurance).

La conciergerie demeure seule responsable vis-à-vis du propriétaire de la bonne exécution du mandat de gestion. Havenly ne peut être tenu responsable d'un manquement à cette obligation.`,
      },
      {
        heading: "3. Reversement automatique au propriétaire",
        text: `Lorsqu'un propriétaire a connecté son compte Stripe via le portail propriétaire Havenly, les reversements s'effectuent de la façon suivante :

• À chaque réservation confirmée, le montant dû au propriétaire est calculé automatiquement après déduction de la commission Havenly (8% ou 12%) et des honoraires de la conciergerie tels que configurés.
• Le reversement est effectué directement sur le compte Stripe du propriétaire dans les 24h suivant le check-in du voyageur.
• Les honoraires de la conciergerie lui sont reversés séparément et simultanément sur son propre compte Stripe.
• Havenly garantit la séparation stricte des flux financiers entre propriétaire et conciergerie.

Si le propriétaire n'a pas encore connecté son compte Stripe, l'intégralité du reversement est versée à la conciergerie, qui reste seule responsable du reversement contractuel au propriétaire.`,
      },
      {
        heading: "4. Portail propriétaire",
        text: `Havenly met à disposition de chaque propriétaire un portail personnel accessible via un lien sécurisé unique, lui permettant de consulter en lecture seule :

• Le calendrier de disponibilités et de réservations de son bien.
• L'historique et le détail de ses réservations.
• Ses revenus perçus, mois par mois.
• L'annonce publique de son bien telle que vue par les voyageurs.

Ce portail est fourni à titre informatif. Le propriétaire ne peut pas modifier l'annonce directement — toute modification doit passer par la conciergerie mandatée.

Le lien d'accès au portail est personnel et confidentiel. Le propriétaire est responsable de sa non-divulgation à des tiers.`,
      },
      {
        heading: "5. Transparence financière",
        text: `Havenly s'engage à garantir une transparence totale des flux financiers entre toutes les parties :

• Le propriétaire peut consulter à tout moment le détail de ses revenus, le montant de la commission Havenly et les honoraires de la conciergerie via son portail personnel.
• Le split de reversement (pourcentage ou forfait fixe) est défini lors de la création de l'annonce par la conciergerie et ne peut être modifié rétroactivement sans accord du propriétaire.
• Havenly ne perçoit aucune rémunération supplémentaire au titre de la relation propriétaire-conciergerie au-delà de sa commission standard sur réservation.`,
      },
      {
        heading: "6. Obligations du propriétaire",
        text: `Le propriétaire s'engage à :

• Être légalement propriétaire ou titulaire d'un droit de jouissance sur le bien mis en location.
• Disposer d'une assurance habitation couvrant la location courte durée.
• Avoir effectué les démarches de déclaration en mairie conformément à la loi Le Meur du 19 novembre 2024.
• Informer la conciergerie de tout changement relatif au bien susceptible d'affecter les réservations.
• Ne pas contacter directement les voyageurs en dehors de la plateforme Havenly sans accord de la conciergerie.`,
      },
      {
        heading: "7. Résiliation et fin de relation",
        text: `En cas de fin de mandat entre le propriétaire et la conciergerie :

• Les réservations déjà confirmées sont honorées jusqu'à leur terme dans les conditions prévues.
• L'accès de la conciergerie à la gestion du bien est révoqué sur demande écrite du propriétaire à contact@havenly.fr.
• Le propriétaire peut demander la reprise directe de la gestion de son annonce en créant un compte hôte sur Havenly.
• Havenly se réserve le droit de suspendre une annonce en cas de litige non résolu entre propriétaire et conciergerie.`,
      },
      {
        heading: "8. Contact et litiges",
        text: `Pour toute question relative à la relation propriétaire-conciergerie ou au portail propriétaire : contact@havenly.fr.

En cas de litige entre un propriétaire et une conciergerie, Havenly peut proposer une médiation informelle mais n'est pas partie au mandat de gestion et ne peut être contraint d'arbitrer un différend contractuel entre ces deux parties.`,
      },
    ],
  },
};

export default function LegalPage({ onNavigate, legalPage }) {
  const [activePage, setActivePage] = useState(legalPage || 'cgu');
  const isMobile = window.innerWidth < 768;
  const section = SECTIONS[activePage] || SECTIONS['cgu'];

  const tabs = [
    { key: 'cgu',             label: 'CGU' },
    { key: 'cgv',             label: 'CGV' },
    { key: 'confidentialite', label: 'Confidentialité' },
    { key: 'cookies',         label: 'Cookies' },
    { key: 'mentions',        label: 'Mentions légales' },
    { key: 'proprietaires',   label: 'Propriétaires & Conciergeries' },
  ];

  return (
    <div style={{ background: 'var(--surface)', minHeight: '100vh', paddingTop: 60 }}>

      {/* Header */}
      <div style={{ background: 'var(--white)', borderBottom: '1px solid var(--border)', padding: isMobile ? '1.5rem 1rem 0' : '2rem 2rem 0' }}>
        <div style={{ maxWidth: 900, margin: '0 auto' }}>
          <button onClick={() => onNavigate('home')} style={{ background: 'none', border: 'none', fontSize: 13, color: 'var(--ink-3)', cursor: 'pointer', padding: 0, marginBottom: 12 }}>
            ← Retour
          </button>
          <h1 style={{ fontFamily: 'var(--serif)', fontSize: isMobile ? 22 : 28, letterSpacing: '-0.5px', marginBottom: 20 }}>
            Informations légales
          </h1>
          <div style={{ display: 'flex', gap: 0, overflowX: 'auto' }}>
            {tabs.map(tab => (
              <button key={tab.key} onClick={() => setActivePage(tab.key)} style={{
                padding: isMobile ? '10px 12px' : '12px 20px',
                border: 'none', background: 'transparent', cursor: 'pointer',
                fontFamily: 'var(--sans)', fontSize: isMobile ? 12 : 14,
                borderBottom: activePage === tab.key ? '2px solid var(--ink)' : '2px solid transparent',
                color: activePage === tab.key ? 'var(--ink)' : 'var(--ink-3)',
                fontWeight: activePage === tab.key ? 500 : 400,
                whiteSpace: 'nowrap',
              }}>
                {tab.label}
              </button>
            ))}
          </div>
        </div>
      </div>

      {/* Contenu */}
      <div style={{ maxWidth: 900, margin: '0 auto', padding: isMobile ? '1.5rem 1rem' : '2.5rem 2rem' }}>
        <div style={{ background: 'var(--white)', border: '1px solid var(--border)', borderRadius: 16, padding: isMobile ? '1.5rem' : '2.5rem' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 32, flexWrap: 'wrap', gap: 8 }}>
            <h2 style={{ fontFamily: 'var(--serif)', fontSize: isMobile ? 20 : 26, letterSpacing: '-0.5px' }}>
              {section.title}
            </h2>
            <span style={{ fontSize: 12, color: 'var(--ink-4)', background: 'var(--surface)', padding: '4px 12px', borderRadius: 20 }}>
              Mis à jour le {section.lastUpdate}
            </span>
          </div>

          <div style={{ display: 'flex', flexDirection: 'column', gap: 28 }}>
            {section.content.map((block, i) => (
              <div key={i} style={{ borderBottom: i < section.content.length - 1 ? '1px solid var(--border)' : 'none', paddingBottom: i < section.content.length - 1 ? 28 : 0 }}>
                <h3 style={{ fontSize: 15, fontWeight: 600, marginBottom: 12, color: 'var(--ink)' }}>{block.heading}</h3>
                <div style={{ fontSize: 14, color: 'var(--ink-3)', lineHeight: 1.9, whiteSpace: 'pre-line' }}>
                  {block.text}
                </div>
              </div>
            ))}
          </div>

          {/* Contact légal */}
          <div style={{ marginTop: 40, padding: '20px 24px', background: 'var(--green-light)', border: '1px solid var(--green)', borderRadius: 12 }}>
            <div style={{ fontSize: 14, fontWeight: 500, color: 'var(--green-mid)', marginBottom: 6 }}>
              Une question sur nos documents légaux ?
            </div>
            <div style={{ fontSize: 13, color: 'var(--green-mid)', lineHeight: 1.6 }}>
              Contactez-nous à <strong>contact@havenly.fr</strong> — réponse sous 5 jours ouvrés.<br />
              Pour exercer vos droits RGPD ou signaler un contenu illicite, précisez l'objet dans votre email.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
